{
  "pt": {
    "milestone": {
      "actions": {
        "activate": "Ativar",
        "active": "Ativo!",
        "create": "Criar marco",
        "deactivate": "Desativar",
        "delete": "Eliminar",
        "delete_milestones": "Eliminar marco | Eliminar {count} marcos",
        "new": "Marco"
      },
      "labels": {
        "bulk_assign_title": "Selecionar as unidades a que pretende atribuir o marco '{milestone_name}'",
        "edit_units": "Editar unidades",
        "empty_state_subtitle": "As etapas tornam o processo de construção mais transparente para os compradores de casa",
        "empty_state_title": "Criar uma nova etapa",
        "future_milestones": "Marcos futuros",
        "milestone": "Marco histórico",
        "milestone_name": "Nome da etapa",
        "milestone_unit_count": "0 unidades | 1 unidade | {count} unidades",
        "milestones": "Marcos históricos",
        "new_milestone": "Novo marco",
        "no_milestone": "Ainda não foi atribuída nenhuma etapa",
        "no_results": "Não foram encontrados marcos",
        "past_milestones": "Marcos anteriores",
        "please_select": "Selecionar uma nova etapa",
        "position": "Posição",
        "search_empty_state": "Ainda não foram criados marcos. Clique aqui para começar",
        "units": "Unidades",
        "units_without_milestone": "1 unidade sem marco | {count} unidades sem marco",
        "warning_delete": "Se eliminar uma etapa que tenha sido atribuída a uma unidade, o cliente perderá a noção da etapa em que se encontra a sua unidade. Certifique-se de que atribui uma nova etapa a estas unidades!"
      },
      "toasts": {
        "bulk_assigned": "A etapa é atribuída com êxito às unidades seleccionadas",
        "create_success": "Marco criado com sucesso",
        "deactivate_success": "O marco foi desativado com sucesso",
        "sup_assigned": "A etapa foi activada com êxito",
        "update_success": "Os marcos foram actualizados com sucesso"
      },
      "validation": {
        "needName": "Nome necessário"
      }
    }
  }
}